import { Body1Strong, Button, Card, CardHeader, Combobox, InfoLabel, Label, makeStyles, Option, Subtitle1, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, tokens } from "@fluentui/react-components";
import LinkWithIcon from "../../LinkWithIcon";
import { useState } from "react";

const useStyles = makeStyles({
    branchDropdown: {
        display: "flex",
        gap: "5px",
        alignItems: "center"
    }
});

export default function FlightOps_Overview_Builds() {
    const styles = useStyles();
    const [ selectedBranch, setSelectedBranch ] = useState( "Retail" );
    const [ branchValue, setBranchValue ] = useState( "Retail" );

    return (
        <>
            <p>
                The following builds are active in the selected branch and ring.
            </p>

            <div className={styles.branchDropdown}>
                <Label htmlFor={"flightOpsBranchSelection"}>Branch</Label>
                <Combobox id={"flightOpsBranchSelection"}
                          value={branchValue}
                          selectedOptions={[ selectedBranch ]}
                          onOptionSelect={( _, d ) => {
                              const v = d.optionValue as string;
                              if( v ) {
                                setSelectedBranch( v );
                                setBranchValue( d.optionText as string );
                              }
                          }}
                          onChange={( e ) => {
                              setBranchValue( e.target.value );
                          }}
                          style={{ maxWidth: "200px" }}>
                    <Option key={"br_Retail"} value="Retail">Retail</Option>
                    <Option key={"br_FlightOpsInternal"} value="FlightOpsInternal">FlightOpsInternal</Option>
                </Combobox>
            </div>

            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Canary</TableHeaderCell>
                        <TableHeaderCell>Beta</TableHeaderCell>
                        <TableHeaderCell>Release</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {
                        selectedBranch == "Retail" ?
                            <TableRow>
                                <TableCell>&mdash;</TableCell>
                                <TableCell>&mdash;</TableCell>
                                <TableCell><LinkWithIcon href="/flightops/builds/24e50816-0ce0-481e-be90-6ad98a0700c5" text="1.0.0.0" /></TableCell>
                            </TableRow> :
                        selectedBranch == "FlightOpsInternal" ?
                            <TableRow>
                                <TableCell><LinkWithIcon href="/flightops/builds/449aff4f-c884-4b00-929c-1757b73ba4a0" text="1.1.0.1" /></TableCell>
                                <TableCell><LinkWithIcon href="/flightops/builds/da696800-88a4-4ad3-bcc5-0955e02cc875" text="1.1.0.0" /></TableCell>
                                <TableCell><LinkWithIcon href="/flightops/builds/24e50816-0ce0-481e-be90-6ad98a0700c5" text="1.0.0.0" /></TableCell>
                            </TableRow>
                            : null
                    }
                </TableBody>
            </Table>
        </>
    );
}